module.exports = __webpack_public_path__ + "img/hashtag.ce44be82.svg";